<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-06 15:28:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="searchHint-wrap">
    <div class="searchHint-back"></div>
    <div class="searchHint-top" v-if="paySucceed==1">
      <div class="searchHint-box" v-if="payFlag">
        &nbsp;&nbsp;&nbsp;您的房屋已缴费或不符合在线缴费条件，可能是以下原因：{{message}}，请您携带《用户服务卡》到我公司收费大厅办理缴费业务。咨询电话: {{ heatingLinkmanPhone }}
      </div>
      <div class="searchHint-box" v-else>
        <div style="color: #333333;"><span style="width: 0.14rem;display:inline-block"></span> 您的房屋不符合代办跑漏险条件，原因可能是房屋用途为非居住或已经办理过本年度保险，如有其他疑问请咨询。</div>
        <div style="color: #FF8888;font-size:0.12rem;margin-top:5px"><span class="searchHint-phone"></span><span style="color: #FF8888;">咨询电话: {{ riskLinkmanPhone }} </span></div>
      </div>
    </div>
    <div class="searchHint-top" v-if="noContinueStop">
      <div class="searchHint-box">
        <div style="color: #007B83;"><span style="width: 0.14rem;display:inline-block"></span> 当前房屋不能办理续停业务或已经办理过本年度续停业务,请到我公司收费大厅办理。</div>
        <div style="color: #FF8888;font-size:0.12rem;margin-top:5px"><span class="searchHint-phone"></span><span style="color: #FF8888;">咨询电话: {{ heatingLinkmanPhone }}</span></div>
      </div>
    </div>
    <div class="searchHint-top" v-if="continueStopFail">
      <div class="searchHint-box">
        <div style="color: #007B83;"><span style="width: 0.14rem;display:inline-block"></span> 当前房屋办理续停业务失败,请到我公司收费大厅办理。</div>
        <div style="color: #FF8888;font-size:0.12rem;margin-top:5px"><span class="searchHint-phone"></span><span style="color: #FF8888;">咨询电话: {{ heatingLinkmanPhone }}</span></div>
      </div>
    </div>
    <div class="searchHint-top" v-if="noInfo">
      <div class="searchHint-box">
        <div style="color: #007B83;"><span style="width: 0.14rem;display:inline-block"></span> 填写信息与预留信息不符，请核对输入是否正确或到我公司收费大厅进行更正</div>
      </div>
    </div>
    <div class="searchHint-top" v-if="paySucceed==0">
      <div class="searchHint-box">
        <div style="color: #007B83;"><span style="width: 0.14rem;display:inline-block"></span> 您的卡号已于{{payTime}}缴费成功,不需要再重复缴费。</div>
      </div>
    </div>
    <div class="searchHint-bottom">
      <el-button type="primary" style="background:#007B83;color:#fff;border:none;width:2.7rem;padding:4%" @click="goHome">确认</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data(){
    return{
      payFlag:'',//true 取暖费  法拉色跑漏险
      riskLinkmanPhone:'',
      heatingLinkmanPhone:'',
      payTime:'',
      paySucceed: 2, // 是否缴费过
      noContinueStop:'', // 是否可以续停
      noInfo:'',// 填写信息是否相符
      continueStopFail:'', //续停失败
      message:""
    }
  },

  methods:{
    goHome(){
      this.$router.replace({
        name:'index'
      })
    },
    async getSystemConfig(){
      const res = await this.$http.get(`${this.$url.globalurl}/systemConfig/${sessionStorage.getItem('customer_id')}`);
      this.heatingLinkmanPhone = res.result[0].heating_linkman_phone
      this.riskLinkmanPhone = res.result[0].risk_linkman_phone
    },
  },

  mounted(){
    if(this.$route.query){
      if(this.$route.query.noInfo){
        this.noInfo = this.$route.query.noInfo;
      }else if(this.$route.query.continueStopFail) {
         this.continueStopFail = this.$route.query.continueStopFail;
      }else if(this.$route.query.noContinueStop) {
         this.noContinueStop = this.$route.query.noContinueStop;
      }else {
        this.payFlag = this.$route.query.payFlag;
        this.paySucceed = this.$route.query.payTime ?  0 : 1;
        this.payTime = moment(this.$route.query.payTime).format('YYYY-MM-DD');
        this.message = this.$route.query.message;
      }
    }
    document.title = "查询结果";
    this.getSystemConfig();
  }
}
</script>
<style lang='scss' scoped>
@import url(searchHint.scss);
</style>
